module.exports = __webpack_public_path__ + "assets/img/img301.1cd7f721.png";